import api, { TipoOptions } from './api';
import { OptionProps } from '@digital/ui';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';

export interface ConsolidadoPluriAnualRelatorioADistribuirResult {
    projetoCodigo: string
    codigoPacote: string
    consolidadoPlurianualConsolidadoPlurianualNomePacote: string
    consolidadoPlurianualADistribuir: number;
    consolidadoPlurianualADistribuirFormat: string;
    numeroLinha: number;
    valorFormatado: string;
    executadoFormatado: string;    
    executadoAnosAnterioFormatado: string;
}

export const getRelatorioConsolidadoPlurianualADistribuirMenorQueZero = () => {
    return api.get<ConsolidadoPluriAnualRelatorioADistribuirResult[]>('consolidadoPlurianual/getRelatorioConsolidadoPlurianualADistribuirMenorQueZero');
}

export const getAllVerificarPluriAnualDiferenteDeZero = () => {
    return api.get<ConsolidadoPluriAnualRelatorioADistribuirResult[]>('consolidadoPlurianual/getAllVerificarPluriAnualDiferenteDeZero');
}



export const exportarVerificarPluriAnualDiferenteDeZero = (nomeDoArquivo: string) => {
    const urlBase = window.location.origin;

    trackPromise(
        Axios.get(`${urlBase}/api/consolidadoPlurianual/exportarVerificarPluriAnualDiferenteDeZero/`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeDoArquivo);
            link.setAttribute('id', 'downloadElementexportarVerificarPluriAnualDiferenteDeZero');
            document.body.appendChild(link);
            link.click();
            document.getElementById('downloadElementexportarVerificarPluriAnualDiferenteDeZero').outerHTML = '';
        }),
    );
};



export const exportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero = (nomeDoArquivo: string) => {
    const urlBase = window.location.origin;

    trackPromise(
        Axios.get(`${urlBase}/api/consolidadoPlurianual/exportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero/`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeDoArquivo);
            link.setAttribute('id', 'downloadElementexportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero');
            document.body.appendChild(link);
            link.click();
            document.getElementById('downloadElementexportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero').outerHTML = '';
        }),
    );
};